<template lang="pug">
.container.grid-xl.py-2.manual-page
  .columns
    .column.col-12
      router-link.btn.btn-link.btn-sm(:to="{ name: 'app.manuais' }")
        i.fa.fa-arrow-left.fa-fw
        |  Voltar aos manuais

      h4.h4 Configurações — Modelos de Documento: Listagem
      p.text-gray Manual do usuário · OS-m Admin v1.84+

      h5.h5 Visão geral
      p
        | Esta parte explica como
        strong  listar
        | ,
        strong  filtrar
        |  e
        strong  abrir
        |  modelos de documento em
        strong  Configurações → Modelos de Documento
        | .

      .toast.toast-primary
        | Exige a permissão
        strong  Sistema → Modelos de documento → Listar
        | . Para
        strong  Editar
        |  e
        strong  Imprimir
        |  o modelo, use também
        strong  Sistema → Modelos de documento → Alterar
        | .

      h5.h5 1. Abrir Modelos de Documento
      ol
        li No menu lateral, clique em
          strong  Configurações
          | .
        li Clique em
          strong  Modelos de Documento
          | .
      p Você chega à listagem de modelos.

      h5.h5 2. Listagem
      p
        | A tabela mostra
        strong  ID
        | ,
        strong  Tipo
        |  (Notificação, Auto, Termo etc.),
        strong  Título
        |  e
        strong  Descrição
        | .
      figure.manual-figure
        img(:src="imgLista" alt="Listagem de modelos de documento")
      ol
        li Role a lista e use a paginação no rodapé se houver várias páginas.
        li Em cada linha, abra o menu da
          strong  engrenagem
          |  para
          strong  Editar
          |  (assistente de 9 passos) ou
          strong  Imprimir
          |  (abre o modelo em nova aba).

      h5.h5 3. Filtros
      p
        | Acima da tabela ficam
        strong  ID
        | ,
        strong  Tipo
        | ,
        strong  Descrição
        |  e o interruptor
        strong  Apenas ativos
        |  (marcado por padrão).
      ol
        li Preencha os critérios desejados.
        li Clique no ícone de
          strong  filtro
          |  para aplicar a busca (a paginação volta à página 1).

      h5.h5 4. Criar novo modelo
      ol
        li Clique no botão
          strong  +
          |  (Adicionar).
        li Escolha o
          strong  tipo de documento
          |  permitido (Notificação, Auto, Termo etc.).
        li O assistente de criação abre na etapa
          strong  Informações
          |  — veja o manual
          strong  Modelos de Documento: Criação e edição
          | .

      .divider
      router-link.btn.btn-primary(:to="{ name: 'app.manuais' }")
        i.fa.fa-book.fa-fw
        |  Voltar à lista de manuais
</template>

<script>
export default {
  data() {
    return {
      imgLista: require("@/assets/manuais/33-config-modelos-doc-lista.png"),
    }
  },
}
</script>

<style lang="stylus" scoped>
.manual-page
  h5
    margin-top 1.5rem

  .manual-figure
    margin 1rem 0
    img
      max-width 100%
      height auto
      border 1px solid #e7e9ed
      border-radius 4px

  .toast
    margin 1rem 0
</style>
